import { render, staticRenderFns } from "./CarreraAgregar.vue?vue&type=template&id=8200790c"
import script from "./CarreraAgregar.vue?vue&type=script&lang=js"
export * from "./CarreraAgregar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports